/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Applicationpreference } from '../models/applicationpreference';
import { appPreferencesGetPreferences } from '../fn/app-preferences/app-preferences-get-preferences';
import { AppPreferencesGetPreferences$Params } from '../fn/app-preferences/app-preferences-get-preferences';

@Injectable({ providedIn: 'root' })
export class AppPreferencesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appPreferencesGetPreferences()` */
  static readonly AppPreferencesGetPreferencesPath = '/api/AppPreferences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appPreferencesGetPreferences()` instead.
   *
   * This method doesn't expect any request body.
   */
  appPreferencesGetPreferences$Response(params?: AppPreferencesGetPreferences$Params, context?: HttpContext): Observable<StrictHttpResponse<Applicationpreference>> {
    return appPreferencesGetPreferences(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appPreferencesGetPreferences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appPreferencesGetPreferences(params?: AppPreferencesGetPreferences$Params, context?: HttpContext): Observable<Applicationpreference> {
    return this.appPreferencesGetPreferences$Response(params, context).pipe(
      map((r: StrictHttpResponse<Applicationpreference>): Applicationpreference => r.body)
    );
  }

}
